import React from "react";
import {
  Responsive,
  NumberField,
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton
} from "admin-on-rest";
import IconTitle from "../components/icon_title";
import Pagination from "../components/pagination";
import { OrderEdit as edit } from "./Create";
import { FullNameField, OrdersFilter, OrdersActions, StatusField } from './OrderValues';
import { styles } from "./styles";
import "./index.css";

export const OrderEdit = edit;

export const OrdersList = props => (
  <List
    {...props}
    actions={<OrdersActions />}
    title={<IconTitle icon="orders" title={"resources.orders.title"} />}
    filters={<OrdersFilter />}
    sort={{ field: "created_at", order: "DESC" }}
    perPage={20}
    pagination={<Pagination />}
  >
    <Responsive
      small={
        <Datagrid bodyOptions={{ showRowHover: true }}>
          <TextField source="ref" label="resources.orders.fieldList.order" />
          <FullNameField
            label="resources.orders.fieldList.customer"
            source="customer_info.first_name"
          />
          <StatusField
            label="resources.orders.fieldList.status"
            source="status"
          />
          <EditButton label="" style={{ textAlign: "right" }} />
        </Datagrid>
      }
      medium={
        <Datagrid bodyOptions={{ showRowHover: true }}>
          <TextField source="ref" label="resources.orders.fieldList.order" />
          <FullNameField
            label="resources.orders.fieldList.customer"
            source="customer_info.first_name"
          />
          <StatusField
            label="resources.orders.fieldList.status"
            source="status"
          />
          <NumberField
            label="resources.orders.fieldList.total"
            source="amounts.total"
            options={{ style: "currency", currency: "IDR" }}
          />
          <EditButton label="" style={{ textAlign: "right" }} />
        </Datagrid>
      }
      large={
        <Datagrid bodyOptions={{ showRowHover: true }}>
          <TextField source="ref" label="resources.orders.fieldList.order" />
          <FullNameField
            label="resources.orders.fieldList.customer"
            source="customer_info.first_name"
            sortable={false}
          />
          <StatusField
            label="resources.orders.fieldList.status"
            source="status"
          />
          <NumberField
            label="resources.orders.fieldList.total"
            source="amounts.total"
            options={{ style: "currency", currency: "IDR" }}
            sortable={false}
          />
          <DateField
            source="created_at"
            label="resources.orders.fieldList.created_at"
            style={styles.dataGridLabel}
            headerStyle={styles.dataGridHeaderLabel}
            showTime
          />
          <EditButton label="" style={{ textAlign: "right" }} />
        </Datagrid>
      }
    />
  </List>
);
/*<FullNameField label="resources.orders.fieldList.customer"  source="customer_info.last_name" style={styles.dataGridLabel}
  headerStyle={styles.dataGridHeaderLabel} />*/
/*<FullNameField label="resources.orders.fieldList.customer"  source="customer_info.last_name" style={styles.dataGridLabel}
  headerStyle={styles.dataGridHeaderLabel} />*/



// WEBPACK FOOTER //
// ./src/orders/index.js